import { render, staticRenderFns } from "./GenerateBilling.vue?vue&type=template&id=c6b672bc&scoped=true&"
import script from "./GenerateBilling.vue?vue&type=script&lang=js&"
export * from "./GenerateBilling.vue?vue&type=script&lang=js&"
import style0 from "./GenerateBilling.vue?vue&type=style&index=0&id=c6b672bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b672bc",
  null
  
)

export default component.exports